






import { Component, Vue, Prop } from "vue-property-decorator";
import { Type } from "../models/message";

@Component
export default class ContactTypeLabel extends Vue {
  @Prop({ required: true, type: String }) public value!: Type;

  get label(): string {
    switch (this.value) {
      case Type.global:
        return this.$t("contact.messageTypes.global").toString();
      case Type.relationProfile:
        return this.$t("contact.messageTypes.relationProfile").toString();
      default:
        return this.value;
    }
  }

  get color(): string {
    switch (this.value) {
      case Type.relationProfile:
        return "primary";
      default:
        return "accent";
    }
  }
}
